// Shared video lightbox (resources/views/partials/video-lightbox.twig).
// Open it from anywhere with:
//   window.dispatchEvent(new CustomEvent("cg-video-lightbox", { detail: { html, label } }))
document.addEventListener("alpine:init", () => {
  window.Alpine.data("videoLightbox", () => ({
    open: false,
    label: "Video",
    init() {
      window.addEventListener("cg-video-lightbox", (event) => this.show(event.detail || {}));
    },
    show({ html, label }) {
      if (!html) return;
      this.label = label || "Video";
      this.$refs.media.innerHTML = html;
      this.open = true;
    },
    // Emptying the panel detaches the iframe, which is what actually stops playback.
    close() {
      this.open = false;
      this.$refs.media.replaceChildren();
    },
  }));
});
